<template>
  <div class="item">
    <div class="thumbnail">
      <img :src="image" class="image" />
      <div class="recharge" v-if="recharge">
        <div v-html="require('../../../icons/recharge.svg')" />
      </div>
    </div>
    <div class="information">
      <h4 class="h5 title">{{ title }}</h4>
      <div>
        <p v-if="comparePrice" class="compare-price">{{ $formatMoney(this.original_line_price) }}</p>
        <p class="price">{{ $formatMoney(this.line_price) }}</p>
      </div>
      <div class="actions">
        <div class="incrementer">
          <button
            class="incrementer__button"
            :disabled="processing || quantity === 1"
            @click="increment(-1)"
          >
            <i class="fal fa-minus"></i>
          </button>
          <span class="quantity">{{ quantity }}</span>
          <button
            class="incrementer__button"
            :disabled="processing"
            @click="increment(+1)"
          >
            <i class="fal fa-plus"></i>
          </button>
        </div>
        <button class="remove" :disabled="processing" @click="remove">
          {{ $translations.cart.general.remove }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      processing: false,
    };
  },
  props: ['lineKey','image', 'title', 'price', 'line_price', 'original_line_price', 'variant_id', 'quantity', 'recharge'],
  methods: {
    ...mapActions({
      cartChange: "cart/change",
    }),
    async increment(amount) {
      this.processing = true;
      await this.cartChange({
        id: this.lineKey,
        quantity: this.quantity + amount,
      });
      this.processing = false;
    },
    async remove() {
      this.processing = true;
      await this.cartChange({
        id: this.lineKey,
        quantity: 0,
      });
      this.processing = false;
    },
  },
  computed: {
    comparePrice() {
      return this.line_price < this.original_line_price;
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
}

.thumbnail {
  width: 112px;
  align-self: flex-start;
  background-color: $white-off;
  padding: 16px 8px;
  position: relative;
  overflow: hidden;
}
.image {
  width: 100%;
}

.recharge {
  background-color: $white;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.06);
  width: 36px;
  height: 36px;
  border-radius: 18px;
  position: absolute;
  top: 16px;
  right: 16px;
  ::v-deep {
    svg {
      width: 100%;
      transform: scale(0.5) translate(-1px, -6px);
    }
  }

  @include media("<=tablet") {
    top: 8px;
    right: 8px;
  }

  @include media("<=phone") {
    top: 4px;
    right: 4px;
    width: 28px;
    height: 28px;
  }
}

.information {
  margin-left: 24px;
  padding: 8px 0;
  flex: 1;
}

.title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
}

.price,
.compare-price {
  margin-top: 8px;
  margin-bottom: 0;
  font-family: $font-family-mono;
}

.compare-price {
  opacity: 0.333;
  text-decoration: line-through;
}

.actions {
  display: flex;
  margin-top: 24px;
  align-items: center;
}

.incrementer {
  display: flex;
  align-items: center;

  &__button {
    @include button-reset();
  }

  .quantity {
    margin: 0 8px;
    width: 16px;
    text-align: center;
  }
}

.remove {
  @include button-reset();
  margin-left: 48px;
  font-family: $font-family-mono;
  font-size: 14px;
  color: #334242;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>
